module.exports = __webpack_public_path__ + "img/logo_inaoe.7aff52fd.png";